import type { AdFields } from '../../types';
import { SiteSections } from '../../types';
import * as BirthdaysPageAds from './birthdays';
import * as DiscoExploreAds from './disco-explore';
import * as DiscoUpdatesAds from './disco-updates';
import * as JobsInlineAds from './jobs-inline';
import * as JobsJobListAds from './jobs-job-list';
import * as JobsRecommendationAds from './jobs-recommendation';
import * as JobsRecommendationMyJobsAds from './jobs-recommendation-my-jobs';
import * as LogoutPageAds from './logout';
import * as ProfilePageAds from './profile';
import * as StartPageAds from './startpage';
import * as SupiNetworkHomeAds from './supi-network-home';

interface AdsBySection {
  [key: string]: Record<string, React.LazyExoticComponent<React.FC<AdFields>>>;
}

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const ads = {
  [SiteSections.DiscoExplore]: DiscoExploreAds,
  [SiteSections.DiscoUpdates]: DiscoUpdatesAds,
  [SiteSections.SupiNetworkHome]: SupiNetworkHomeAds,
  [SiteSections.JobsInline]: JobsInlineAds,
  [SiteSections.JobsJobList]: JobsJobListAds,
  [SiteSections.JobsRecommendation]: JobsRecommendationAds,
  [SiteSections.JobsRecommendationMyJobs]: JobsRecommendationMyJobsAds,
  [SiteSections.StartPage]: StartPageAds,
  [SiteSections.Birthdays]: BirthdaysPageAds,
  [SiteSections.Profile]: ProfilePageAds,
  [SiteSections.Logout]: LogoutPageAds,
} as AdsBySection;

export default ads;
